import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const Styled = {
    Container: styled(Box)(({ theme }) => {
        return {
            width: '100%',
            maxWidth: '450px',
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                maxWidth: '340px',
            },
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            margin: '0 auto',

            '&.has-error': {
                '.bank-card': {
                    background: theme.palette.error.main,
                },
                '.fake-bank-card': {
                    background: theme.palette.error.main,
                },
            },
        };
    }),
    BankCard: styled(Box)(({ theme }) => {
        return {
            position: 'absolute',
            overflow: 'hidden',
            width: '100%',
            height: '100%',
            boxShadow: theme.shadows[1],
            borderRadius: 8,
            opacity: '0.5',
            transform: 'rotate3d(2, 0, 1, 344deg)',
            background: theme.palette.gradientButton.base,
            zIndex: 1,
        };
    }),
};

export { Styled };
